"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveReadManifestService = exports.ManifestConfigService = exports.ReadManifestService = exports.PublishedStatusesParseError = exports.GetAllPublishedStatusesForTenantError = exports.ProductStatusParseError = exports.GetByProductIdError = exports.ManifestParseError = exports.GetManifestForProductError = exports.GetAllForTenantError = void 0;
const effect_1 = require("effect");
// import { HttpService } from '../http';
const HttpClient = __importStar(require("@effect/platform/HttpClient"));
const requests_1 = require("./requests");
const resolvers_1 = require("./resolvers");
const Manifest = __importStar(require("./service"));
class GetAllForTenantError extends effect_1.Data.TaggedError('@fixtuur/backpack/Manifest/GetAllForTenantError') {
}
exports.GetAllForTenantError = GetAllForTenantError;
class GetManifestForProductError extends effect_1.Data.TaggedError('@fixtuur/backpack/Manifest/GetManifestForProductError') {
}
exports.GetManifestForProductError = GetManifestForProductError;
class ManifestParseError {
    constructor(originalError, humanReadableError) {
        this.originalError = originalError;
        this.humanReadableError = humanReadableError;
        this._tag = '@fixtuur/backpack/Manifest/ManifestParseError';
    }
}
exports.ManifestParseError = ManifestParseError;
class GetByProductIdError extends effect_1.Data.TaggedError('@fixtuur/backpack/Manifest/GetByProductIdError') {
}
exports.GetByProductIdError = GetByProductIdError;
class ProductStatusParseError {
    constructor(originalError, humanReadableError) {
        this.originalError = originalError;
        this.humanReadableError = humanReadableError;
        this._tag = '@fixtuur/backpack/Manifest/ProductStatusParseError';
    }
}
exports.ProductStatusParseError = ProductStatusParseError;
class GetAllPublishedStatusesForTenantError extends effect_1.Data.TaggedError('@fixtuur/backpack/Manifest/GetAllPublishedStatusesForTenantError') {
}
exports.GetAllPublishedStatusesForTenantError = GetAllPublishedStatusesForTenantError;
class PublishedStatusesParseError {
    constructor(originalError, humanReadableError) {
        this.originalError = originalError;
        this.humanReadableError = humanReadableError;
        this._tag = '@fixtuur/backpack/Manifest/PublishedStatusesParseError';
    }
}
exports.PublishedStatusesParseError = PublishedStatusesParseError;
/**
 * Provide access to the Manifest Service, which provides information at a
 * Product level about what products are published, explicitly unpublished, or
 * incomplete across each of our software solutions.
 */
class ReadManifestService extends effect_1.Context.Tag('@fixtuur/backpack/Services/ReadManifestService')() {
}
exports.ReadManifestService = ReadManifestService;
class ManifestConfigService extends effect_1.Context.Tag('@fixtuur/backpack/Services/ManifestConfigService')() {
}
exports.ManifestConfigService = ManifestConfigService;
exports.LiveReadManifestService = effect_1.Layer.effect(Manifest.ReadManifestService, effect_1.Effect.gen(function* (_) {
    const http = yield* HttpClient.HttpClient;
    const { manifestUrl } = yield* _(ManifestConfigService);
    const getCheckResultsPageForTenant = (tenant, limit, cursor) => manifestUrl.pipe(effect_1.Effect.flatMap(manifestUrl => effect_1.Effect.request((0, requests_1.GetCheckResultsForTenant)({ tenant, limit, cursor }), (0, resolvers_1.getCheckResultsForTenantResolver)(http, manifestUrl))));
    const getCheckResultsForTenant = (tenant, limit, cursor) => limit !== undefined
        ? getCheckResultsPageForTenant(tenant, limit, cursor)
        : effect_1.Effect.gen(function* () {
            const LIMIT = 100;
            let combinedManifest = {};
            let nextCursor;
            do {
                const response = yield* getCheckResultsPageForTenant(tenant, LIMIT, nextCursor);
                combinedManifest = Object.assign(Object.assign({}, combinedManifest), response.manifest);
                nextCursor = response.nextCursor;
            } while (nextCursor);
            return {
                manifest: combinedManifest,
            };
        });
    const getCheckResultsForProduct = (tenant, product) => manifestUrl.pipe(effect_1.Effect.flatMap(manifestUrl => effect_1.Effect.request((0, requests_1.GetCheckResultsForProduct)({ tenant, product }), (0, resolvers_1.getCheckResultsForProductResolver)(http, manifestUrl))));
    const getPublishedStatusForProduct = (productId, tenant) => manifestUrl.pipe(effect_1.Effect.flatMap(manifestUrl => effect_1.Effect.request((0, requests_1.GetPublishedStatusForProduct)({ productId, tenant }), (0, resolvers_1.getPublishedStatusForProductResolver)(http, manifestUrl))));
    const getPublishedStatusesPageForTenant = (tenant, limit, cursor) => manifestUrl.pipe(effect_1.Effect.flatMap(manifestUrl => effect_1.Effect.request((0, requests_1.GetPublishedStatusesForTenant)({ tenant, limit, cursor }), (0, resolvers_1.getPublishedStatusesForTenantResolver)(http, manifestUrl))));
    const getPublishedStatusesForTenant = ((tenant, limit, cursor) => limit !== undefined
        ? getPublishedStatusesPageForTenant(tenant, limit, cursor)
        : effect_1.Effect.gen(function* () {
            const LIMIT = 100;
            let combinedStatuses = [];
            let nextCursor;
            do {
                const response = yield* getPublishedStatusesPageForTenant(tenant, LIMIT, nextCursor);
                combinedStatuses = [...combinedStatuses, ...response.statuses];
                nextCursor = response.nextCursor;
            } while (nextCursor);
            return combinedStatuses;
            // Pagination makes this awkward - we always get a paginated response if limit is specified,
            // but typescript loses this information so the assertion here is needed
        }));
    return {
        getCheckResultsForTenant,
        getCheckResultsForProduct,
        getPublishedStatusForProduct,
        getPublishedStatusesForTenant,
    };
}));
